import { render, staticRenderFns } from "./emailLogin.vue?vue&type=template&id=a0a52872&scoped=true&"
import script from "./emailLogin.vue?vue&type=script&lang=js&"
export * from "./emailLogin.vue?vue&type=script&lang=js&"
import style0 from "./emailLogin.vue?vue&type=style&index=0&id=a0a52872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a52872",
  null
  
)

export default component.exports